/**
 * Block Component Registration
 * 
 * This file imports all block components and registers them with the ComponentRegistry.
 * Import this file once at your app's entry point to ensure all components are available.
 */

import ComponentRegistry from './ComponentRegistry.jsx';
import Name from './Name.jsx';

// Import all block components
import { ArtistMetaComponent } from '../blocks/ArtistMeta.jsx';
import { LinkButton } from '../blocks/Button.jsx';
import Columns from '../blocks/Columns.jsx';
import { ContactImageComponent } from '../blocks/ContactImage.jsx';
import { ContactMetaComponent } from '../blocks/ContactMeta.jsx';
import Divider from '../blocks/Divider.jsx';
import Footer from '../blocks/Footer.jsx';
import Image from '../blocks/Image.jsx';
import * as InventoryCell from '../blocks/InventoryCell.jsx';
import { InventoryImageComponent } from '../blocks/InventoryImage.jsx';
import { InventoryMetaComponent } from '../blocks/InventoryMeta.jsx';
import * as InventoryList from '../blocks/InventoryList.jsx';
import Logo from '../blocks/Logo.jsx';
import { RecipientMetaComponent } from '../blocks/RecipientMeta.jsx';
import { ResourceMetaComponent } from '../blocks/ResourceMeta.jsx';
import Social from '../blocks/Social.jsx';
import { HeaderText, TokenizedText } from '../blocks/Text.jsx';

// Register all components
ComponentRegistry.register(Name.Block.Artist.Text, ArtistMetaComponent);
ComponentRegistry.register(Name.Block.Column, Columns.Component);
ComponentRegistry.register(Name.Block.Contact.Image, ContactImageComponent);
ComponentRegistry.register(Name.Block.Contact.Message, ContactMetaComponent);
ComponentRegistry.register(Name.Block.Contact.Offer, ContactMetaComponent);
ComponentRegistry.register(Name.Block.Contact.Text, ContactMetaComponent);
ComponentRegistry.register(Name.Block.Divider, Divider.Component);
ComponentRegistry.register(Name.Block.Footer, Footer.Component);
ComponentRegistry.register(Name.Block.HeaderText, HeaderText.Component);
ComponentRegistry.register(Name.Block.Image, Image.Component);
ComponentRegistry.register(Name.Block.Inventory.Button, InventoryCell.InventoryButton.Component);
ComponentRegistry.register(Name.Block.Inventory.Image, InventoryImageComponent);
ComponentRegistry.register(Name.Block.Inventory.List + '.Campaign', InventoryList.Campaign.Component);
ComponentRegistry.register(Name.Block.Inventory.List + '.Transactional', InventoryList.Transactional.Component);
ComponentRegistry.register(Name.Block.Inventory.Text, InventoryMetaComponent);
ComponentRegistry.register(Name.Block.LinkButton, LinkButton.Component);
ComponentRegistry.register(Name.Block.Logo, Logo.Component);
ComponentRegistry.register(Name.Block.Recipient.Text, RecipientMetaComponent);
ComponentRegistry.register(Name.Block.ResourceText, ResourceMetaComponent);
ComponentRegistry.register(Name.Block.Social, Social.Component);
ComponentRegistry.register(Name.Block.Text, TokenizedText.Component);

export default ComponentRegistry;

